import { ClientLogo } from '@viapeople/components'
import type React from 'react'
import { sessionStore } from '../sharedStores/sessionStore'

const getInitials = (name: string): string => {
	return name
		.split(' ')
		.map((word) => word.charAt(0).toUpperCase())
		.slice(0, 2)
		.join('')
}

export const AppHeader: React.FC = () => {
	const { user, organization } = sessionStore()

	if (!user || !organization) {
		return null
	}

	const userName = `${user.firstName} ${user.lastName}`
	const initials = getInitials(userName)

	return (
		<header className='bg-white border-b border-neutral-200 px-6 py-4'>
			<div className='flex items-center justify-between w-full'>
				<div className='flex-shrink-0'>
					<ClientLogo url={organization.logo} />
				</div>

				<div className='flex items-center gap-3'>
					<div className='flex items-center justify-center w-10 h-10 bg-neutral-100 rounded-full text-sm font-medium text-neutral-700'>
						{initials}
					</div>

					<div className='flex flex-col'>
						<span className='text-sm font-medium text-neutral-900'>{userName}</span>
						<span className='text-xs text-neutral-500'>{user.email}</span>
					</div>
				</div>
			</div>
		</header>
	)
}
